import {
  PublisherOrderStatus,
  PublisherOrderStatusMap,
  PublisherOrderType,
} from 'respona_api/generated/common_pb';
import { PublishersOrderType } from '@ts/publishers.types';

type PublisherOrderStatusValueType = PublisherOrderStatusMap[keyof PublisherOrderStatusMap];

/**
 * Statuses from which the back end swaps `documentUrl` for the published URL
 * (mirrors `GrpcMapper.toPublisherOrderResponse`). Before that `documentUrl`
 * is the working document: the article doc for a guest post, the insertion
 * brief for a pipeline link insertion.
 */
const PUBLISHED_ORDER_STATUSES: ReadonlySet<number> = new Set<number>([
  PublisherOrderStatus.PUBLISHER_ORDER_LIVE,
  PublisherOrderStatus.PUBLISHER_ORDER_PENDING_LIVE,
  PublisherOrderStatus.PUBLISHER_ORDER_INDEXED,
  PublisherOrderStatus.PUBLISHER_ORDER_PAID,
]);

export const isPublishedOrderStatus = (status: PublisherOrderStatusValueType): boolean =>
  PUBLISHED_ORDER_STATUSES.has(status);

export const isLinkInsertionOrder = (order?: PublishersOrderType | null): boolean =>
  !!order && order.type === PublisherOrderType.LINK_INSERTION;

/**
 * The Google Doc brief of a pipeline link insertion, or an empty string when
 * the order has none (manual link insertions, guest posts) or when
 * `documentUrl` already holds the published URL.
 */
export const getInsertionBriefUrl = (order?: PublishersOrderType | null): string => {
  if (!isLinkInsertionOrder(order) || isPublishedOrderStatus(order.status)) {
    return '';
  }

  return order.documentUrl || '';
};
